<template>
  <div class="finish">
    <div class="selectHead">
      布置作业
      <div class="stepBar fr">
        <img src="../../assets/img/step3.png" alt="">
        <p>
          <span class="active">布置对象</span>
          <span class="active">选择内容</span>
          <span class="active">作业留言</span>
        </p>
      </div>
    </div>
    <div class="content">
      <img src="../../../static/new icon/success.png" alt="">
      <p>您的作业已经发布成功！</p>
    </div>
    <div class="footer">
      <button @click="goFun(0)" style="background:#93DACA;">继续布置</button>
      <button @click="goFun(1)">查看作业</button>
    </div>
  </div>
</template>

<style>
.finish {
  width: 100%;
}
.content {
  height: 610px;
  text-align: center;
  vertical-align: middle;
  padding-top: 20%;
}
.content p {
  margin-top: 20px;
  font: normal normal 20px "Microsoft YaHei";
  color: #666666;
}
.finish .footer {
  width: calc(100% - 200px);
  height: 70px;
  background: #fafafa;
  padding: 0;
  text-align: center;
  line-height: 70px;
  position: absolute;
  bottom: 0;
}
.finish .footer button {
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-right: 20px;
  background: #01ba90;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
</style>

<script type="text/javascript">
import { mapActions } from "vuex";
export default {
  data() {
    return {};
  },

  methods: {
    ...mapActions(["setState"]),
    goFun(index) {
      this.setState([0, index]);
      this.$router.push({ path: index ? "home" : "selectGrade" });
    }
  }
};
</script>





// WEBPACK FOOTER //
// publishFinish.vue?39820f0f